import { Injectable } from '@angular/core';

import { sprintf } from 'sprintf-js';

@Injectable()
export class TranslateService {
	private _translations: Map<string, string> = new Map;

	public add(key: string, translation: string) {
		this._translations.set(key, translation.trim());
	}

	public translate(key: string, replacements: { [s: string]: any } = {}) {
		if (Object.keys(replacements).length) {
			return this._translations.has(key) ? sprintf(this._translations.get(key), replacements) : key;
		}

		return this._translations.has(key) ? this._translations.get(key) : key;
	}

	public has(key: string): boolean {
		return this._translations.has(key);
	}

	public entries(): IterableIterator<[string, string]> {
		return this._translations.entries();
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/services/translate.service.ts